"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = initGraphql;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _utils = require("../common/utils");
var _common = require("../common");
function initGraphql() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var wapp = p.wapp;
  var client = wapp.client;
  if (!client.graphql) {
    var defaultMiddleware = function defaultMiddleware(req, res, next) {
      client.graphql.init();
      return next();
    };
    var defaultInit = function defaultInit() {
      if (wapp.states) {
        wapp.states.addHandle({
          requestsFromGraphQl: function requestsFromGraphQl(req, res, next) {
            (0, _common.createRequests)({
              wapp: wapp,
              req: req,
              res: res
            });
            next();
          }
        });
      }
    };
    var defaultGraphqlObject = Object.create(Object.prototype, {
      middleware: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
        value: defaultMiddleware
      }),
      init: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
        value: defaultInit
      })
    });
    Object.defineProperty(client, "graphql", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      writable: false,
      value: defaultGraphqlObject
    }));
    Object.defineProperty(client.graphql, "wapp", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      writable: false,
      enumerable: false,
      value: wapp
    }));
    client.graphql.init();
  }
  return client.graphql;
}